import axios from 'axios'
import { Message } from 'element-ui'
import { BASE_API } from '@/config';

// create an axios instance
const service = axios.create({
  baseURL: BASE_API,
  timeout: 15000, // 保持15秒超时
  withCredentials: true // 跨域请求时发送cookies
})

// function clearAllCookies() {
//   const cookies = document.cookie.split(";");
//   cookies.forEach(cookie => {
//     const eqPos = cookie.indexOf("=");
//     const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie;
//     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
//   });
// }

// request interceptor
service.interceptors.request.use(
  config => {
    // 移除token认证逻辑
    // 不再从localStorage获取token
    // 不再在请求头中添加Authorization
    
    return config
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // console.log(res);
    // console.log(res.resultCode !== '0');
    // if the custom code is not 200, it is judged as an error.
    // console.log(res.resultCode)
    if (res.resultCode !== 0) {
      Message({
        message: res.message || '服务器响应错误',
        type: 'error',
        duration: 1000
      })
      return res
    }
    return res
  },
  error => {
    console.error('响应错误:', error);

    // 处理请求超时
    if (error.code === 'ECONNABORTED' && error.message && error.message.includes('timeout')) {
      Message({
        message: '请求超时，请检查网络或服务器状态',
        type: 'error',
        duration: 3000
      });
      // 返回空结果而不是抛出异常
      return Promise.resolve({
        resultCode: 500,
        message: '请求超时',
        data: null
      });
    }

    // 处理HTTP状态码错误
    if (error.response) {
      switch (error.response.status) {
        case 403: // 禁止访问
          console.log("请检查用户角色权限");
          // Message.error('请检查用户角色权限');
          break;
        case 404: // 资源不存在
          Message.error('请求的资源不存在');
          break;
        case 500: // 服务器错误
          Message.error('服务器错误，请联系管理员');
          break;
        default:
          Message.error('连接错误，请稍后再试');
      }
    } else {
      Message.error('网络连接异常，请检查网络设置');
    }

    return Promise.resolve(error)
  }
)

export default service
